<template>
  <v-container
    fluid>
    <v-row v-if="extraFiles.length!==0">
      <v-col cols="12">
        <v-subheader>Files</v-subheader>
        <v-col
          v-for="extraF in extraFiles"
          :key="extraF.label"
          cols="12"
        >

          <a
            :href="extraF.url"
            target="_blank"
            rel="noopener">
            {{ extraF.label.replace(/_/g, ' ') }}
          </a>

        </v-col>

      </v-col>
    </v-row>

    <v-row
    >
      <v-col
        cols="12"
        v-if="showSubheader">
        <v-subheader>{{ subheaderText }}</v-subheader>
      </v-col>
      <v-col
        cols="12"
        v-if="reports.length === 0 && extraFiles.length===0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          No reports have been published for this child.
        </v-alert>
      </v-col>
      <v-col
        cols="12"
        v-for="report in reports"
        :key="report.name">
        <v-card class="mb-3">
          <v-card-title>
            <a
              :href="report.link"
              @click="trackReport(report)"
              class="black--text font-weight-bold subtitle-1"
              style="text-decoration: none;"
              target="_blank"
              rel="noopener">
              {{ report.name.replace(/_/g, ' ') }}
              <v-icon>fa-external-link-alt</v-icon>
            </a>
          </v-card-title>
          <v-card-text>
            <span
              v-if = "report.formattedDatePubFrom">
              {{ dateTest[0].test1 }} {{ report.formattedDatePubFrom }}</span>
            <span
              v-else>
              {{ report.formattedDatePubTo }}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    reports: [],
    extraFiles: [],
    dateTest: [
      {
        test1: 'Date Published: '
      }
    ]
  }),
  computed: {
    showSubheader () {
      return this.reports.length !== 0 || (this.reports.length === 0 && this.extraFiles.length === 0)
    },
    subheaderText () {
      return this.$store.state.Dbasename === 'PBS' ? 'Published Learning Summary' : 'Published Reports'
    },
    isTeMata () {
      return this.$store.state.Dbasename === 'TeMata'
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)
      // Get Reports
      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/reportsV2')
        .then(resp => {
          vm.reports = resp.data.reports
          vm.extraFiles = resp.data.extraFiles
          vm.$store.commit('loading', false)
        })
    })
  },
  methods: {
    convertURLsToHref: function (stringToConvert) {
      return stringToConvert.replace(/(http)(s)?(:\/\/)(([a-zA-Z])([-\w]+\.)+([^\s.]+[^\s]*)+[^,.\s])/g, "<a href='http$2://$4' class='v-btn theme--light' style='text-decoration: none;' target='_blank' title='$&'>Open Link</a><br>")
    },
    trackReport (report) {
      this.$http.post(
        'pupilsV2/' + this.$store.state.Dbasename + '/' +
      this.$store.state.pupilId + '/' +
      this.$store.state.userId + '/trackReports',
        {
          reportName: report.name,
          buttonLabel: report.buttonLabel || null
        }
      ).catch(() => {
      })
    }
  },
  mounted () {
    this.$store.dispatch('logReadItems')
  }
}
</script>
<style>
</style>
